import React, { useEffect, useState } from "react";
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import NOCDetailsLog from "@egovernments/digit-ui-module-common/src/sharedComponents/NOCDetailsLog";
import DialogContentModal from "../../../../../templates/ApplicationDetails/components/DialogContent";
import NOCShortfallLog from "@egovernments/digit-ui-module-common/src/sharedComponents/NOCShortfallLog";

const NOCInfo = ({ formData, setShowNOCInfo, showNOCInfo, searchNocRemarks, nocRemarksData }) => {
  const { t } = useTranslation();
  const [smShow, setSmShow] = useState(false);
  const [iframeSrc, setIframeSrc] = useState("");

  // Get user details and NOC data from session storage
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const storedData = formData || Digit.SessionStorage.get("nocAppData");
  const termsAndCondition = formData || Digit.SessionStorage.get("nocTermsAndCondition");
  const { nocAppNo, nocSearchResult } = Digit.SessionStorage.get("nocAppNo") || {};
  console.log("resultFromSessionsearch", nocSearchResult, nocAppNo, termsAndCondition, nocRemarksData);

  const nocList = storedData?.nocList || [];
  let user = Digit.UserService.getUser();

  const isCitizen = user?.info?.type === "CITIZEN";
  // Find the NOC item for the current user's organisationCode
  const userOrgCode = userDetails?.organisationCode;
  const item = isCitizen
    ? nocList.find((item) => item.applicationNo == nocAppNo)
    : nocList.find((n) => n.businessService == userDetails?.organisationCode);

  // Table columns (added Department column)
  const columns = [
    { id: "applicationNo", label: "Application Number", width: "17%" },
    { id: "department", label: "Department", width: "13%" },
    { id: "requestLetter", label: "Request Letter", width: "13%" },
    { id: "shortfallLetter", label: "Shortfall Letter", width: "13%" },
    { id: "approvalLetter", label: "Approval Letter", width: "13%" },
    { id: "status", label: "Status", width: "10%" },
    { id: "action", label: "Action", width: "10%" },
  ];

  // Helper to open document in new tab
  const handleOpenDoc = (url) => {
    if (url) window.open(url, "_blank");
  };

  const handleOpenRequestLetter = (url) => {
    setIframeSrc(url);
    setSmShow(true);
  };

  // useEffect(() => {
  //   if (item) searchNocRemarks(item?.applicationNo);
  // }, [searchNocRemarks, item]);
  if (!item) {
    return (
      <div style={{ padding: "24px" }}>
        <Typography variant="h6" align="center">
          No NOC record found for your organization.
        </Typography>
      </div>
    );
  }

  // Find request letter info for this item
  const fileUrl = item.nocLetterInfo?.fileStoreUrl || "";

  return (
    <div style={{ padding: "0px 4px" }}>
      <TableContainer component={Paper} className="table-container">
        <div>
          <caption className="emp-table-caption">NOC Info</caption>
        </div>
        <Table stickyHeader aria-label="noc info table" className="application-table">
          <TableHead>
            <TableRow className="citizen-header-row">
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{
                    width: column.width,
                    fontWeight: "bold",
                    background: "#1f4a7c",
                    color: "#fff",
                    fontSize: "13px",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell style={{ fontSize: "13px" }}>{item.applicationNo || "-"}</TableCell>
              <TableCell style={{ fontSize: "13px" }}>{item.nocName || "-"}</TableCell>
              <TableCell style={{ fontSize: "13px", textAlign: "center" }}>
                {fileUrl ? (
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenRequestLetter(fileUrl)}
                    sx={{ fontSize: "12px", minWidth: "60px" }}
                  >
                    View
                  </Button>
                ) : (
                  "-"
                )}
              </TableCell>
              <TableCell style={{ fontSize: "13px", textAlign: "center" }}>
                {item.nocApprovedLetterUrl && item.applicationStatus === "REVERT_TO_APPLICANT_NOC" ? (
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenDoc(item.nocApprovedLetterUrl)}
                    sx={{ fontSize: "12px", minWidth: "60px" }}
                  >
                    View
                  </Button>
                ) : (
                  "-"
                )}
              </TableCell>
              <TableCell style={{ fontSize: "13px", textAlign: "center" }}>
                {item.nocApprovedLetterUrl && item.applicationStatus === "NOC_APPROVED" ? (
                  <Button
                    size="small"
                    variant="contained"
                    color="success"
                    onClick={() => handleOpenDoc(item.nocApprovedLetterUrl)}
                    sx={{ fontSize: "12px", minWidth: "60px" }}
                  >
                    View
                  </Button>
                ) : (
                  "-"
                )}
              </TableCell>
              <TableCell style={{ fontSize: "13px" }}>{t(`NOC_STATUS_${item.applicationStatus}`) || "-"}</TableCell>
              <TableCell style={{ fontSize: "13px" }}>
                <Box display="flex" flexDirection="row" gap={1}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={() => setShowNOCInfo((prev) => !prev)}
                    sx={{ fontSize: "12px", minWidth: "60px" }}
                  >
                    Take Action
                  </Button>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {iframeSrc && (
        <DialogContentModal
          title={"Application Details"}
          dataOpen={smShow}
          onClose={() => {
            setSmShow(false);
          }}
        >
          <div className="iframe-container">
            <iframe className="fastPas-iframe" src={iframeSrc} title="Document Viewer"></iframe>
          </div>
        </DialogContentModal>
      )}
      <NOCShortfallLog shortfallData={item?.objectionLetterUrl} />
      {<NOCDetailsLog logData={termsAndCondition} nocRemarksData={nocRemarksData} isCitizen={isCitizen} />}
    </div>
  );
};

export default NOCInfo;
